import { render, staticRenderFns } from "./mAppDownload.vue?vue&type=template&id=4ad4fbf1&scoped=true"
import script from "./mAppDownload.vue?vue&type=script&lang=js"
export * from "./mAppDownload.vue?vue&type=script&lang=js"
import style0 from "./mAppDownload.vue?vue&type=style&index=0&id=4ad4fbf1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad4fbf1",
  null
  
)

export default component.exports